// Chakra imports
import ReactApexChart from "react-apexcharts";
import './SecondPage.css';

// Custom components
import React, { useEffect, useState } from "react";

export default function Conversion(props) {
    const { finalData } = props;

    const pieChartOptions = {
        labels: finalData && finalData.length > 0 ? finalData?.map((it) => it.brand || it.sellers || it.platform_name || "unknown") : [],
        colors: [
            "#6ce5e8", "#41b8d5", "#2d8bba", "#2f5f98", "#31356e", "#111D4A",
            "#98D9E1", "#85C1E9", "#5DADE2", "#2E86C1", "#1B4F72", "#0E2F44"
        ],

        chart: {
            width: "50px",
            background: 'transparent',
        },
        states: {
            hover: {
                filter: {
                    type: "none",
                },
            },
        },
        legend: {
            show: false,
            position: 'right'
        },
        dataLabels: {
            enabled: true,
        },
        hover: { mode: null },
        plotOptions: {
            donut: {
                expandOnClick: false,
                donut: {
                    labels: {
                        show: false,
                    },
                },
            },
        },
        fill: {
            colors: ["#6ce5e8", "#41b8d5", "#2d8bba", "#2f5f98", "#31356e", "#111D4A"],
        },
        tooltip: {
            enabled: true,
            theme: "dark",
        },
        grid: {
            show: false
        }
    };

    return (
        <div className="pie-card" style={{ padding: 0, margin: 0, border: 'none', boxShadow: 'none', background: 'none' }}>

            <ReactApexChart
                options={pieChartOptions}
                series={finalData?.map((it) => it.count)}
                type='donut'
            />
        </div>
    );
}